import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import {
  ATTACHMENT_LIST_CLASS,
  ATTACHMENT_ROW_ACTIONS_CLASS,
  ATTACHMENT_ROW_CLASS,
  DOWNLOAD_BUTTON_CLASS,
  ICON_BUTTON_BASE_CLASS,
  REMOVE_SAVED_ATTACHMENT_BUTTON_CLASS,
  SECONDARY_ICON_BUTTON_CLASS,
  UNDO_REMOVAL_BUTTON_CLASS,
  UNDO_REMOVAL_TEXT,
} from "./attachmentPanel.constants";
import { ATTACHMENT_ROW_KINDS } from "./attachmentPanel.state";

const IconButton = ({ className, label, onClick, children }) => (
  <button
    aria-label={label}
    className={`${ICON_BUTTON_BASE_CLASS} ${className}`}
    onClick={onClick}
    title={label}
    type="button"
  >
    {children}
  </button>
);

const SavedRowActions = ({
  onDownloadAttachment,
  onRemoveSavedAttachment,
  onUndoRemoveSavedAttachment,
  row,
}) => {
  if (row.isRemovalPending) {
    return (
      <button
        aria-label={`Undo removing ${row.name}`}
        className={UNDO_REMOVAL_BUTTON_CLASS}
        onClick={() => onUndoRemoveSavedAttachment(row.blobName)}
        type="button"
      >
        {UNDO_REMOVAL_TEXT}
      </button>
    );
  }

  return (
    <>
      {row.canDownload && (
        <IconButton
          className={DOWNLOAD_BUTTON_CLASS}
          label={`Download ${row.name}`}
          onClick={() => onDownloadAttachment(row.attachment)}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>
      )}
      <IconButton
        className={REMOVE_SAVED_ATTACHMENT_BUTTON_CLASS}
        label={`Remove ${row.name}`}
        onClick={() => onRemoveSavedAttachment(row.blobName)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );
};

const AttachmentRowActions = ({ onClearSelectedFile, row, ...savedActions }) => {
  if (row.kind === ATTACHMENT_ROW_KINDS.SELECTED) {
    return (
      <IconButton
        className={SECONDARY_ICON_BUTTON_CLASS}
        label={`Remove ${row.name}`}
        onClick={() => onClearSelectedFile(row.fileKey)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    );
  }

  return <SavedRowActions row={row} {...savedActions} />;
};

const AttachmentRow = ({ row, ...actionHandlers }) => (
  <li className={ATTACHMENT_ROW_CLASS} data-testid="attachment-row">
    <div className="min-w-0">
      <p className="truncate text-sm font-medium text-text">{row.name}</p>
      <p className="text-xs text-text-muted">{row.metaText}</p>
    </div>
    <div className={ATTACHMENT_ROW_ACTIONS_CLASS}>
      <AttachmentRowActions row={row} {...actionHandlers} />
    </div>
  </li>
);

const AttachmentList = ({ rows, ...actionHandlers }) => {
  if (!rows.length) return null;

  return (
    <ul aria-label="Attached files" className={ATTACHMENT_LIST_CLASS}>
      {rows.map((row) => (
        <AttachmentRow key={row.key} row={row} {...actionHandlers} />
      ))}
    </ul>
  );
};

export default AttachmentList;
